// extracted by mini-css-extract-plugin
module.exports = {"checkBoxSpinner":"CheckBoxSpinner-checkBoxSpinner-aerdg","spin":"CheckBoxSpinner-spin-CdOC3"};